export const passthroughList = [
  "sin", "cos", "tan", "cot", "sec", "csc",
  "arcsin", "arccos", "arctan",
  "log", "ln", "max", "min", "exp", "det", "mod",
  "sinh", "cosh", "tanh", "coth", "gcd"
];